import { render, staticRenderFns } from "./logicSet.vue?vue&type=template&id=61896273&scoped=true"
import script from "./logicSet.vue?vue&type=script&lang=ts"
export * from "./logicSet.vue?vue&type=script&lang=ts"
import style0 from "./logicSet.vue?vue&type=style&index=0&id=61896273&prod&lang=less"
import style1 from "./logicSet.vue?vue&type=style&index=1&id=61896273&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61896273",
  null
  
)

export default component.exports